import { post } from "./client";
import { type OkResponse, type TypedUrl, url } from "./common";
import type { WorkshopId } from "./workshop";

export type SparkChatInfoDto =
  | { enabled: false }
  | {
      enabled: true;
      maxMessageLength: number;
      messagesLeft: number;
      debug: boolean;
    };

export const sparkChatPath = (workshopId: WorkshopId, blockKey: string) =>
  `/workshops/${workshopId}/spark-chat/${encodeURIComponent(blockKey)}`;

export const sparkChatModels = {
  SPARK_CHAT_INFO: (
    workshopId: WorkshopId,
    blockKey: string,
  ): TypedUrl<SparkChatInfoDto> =>
    url<SparkChatInfoDto>(sparkChatPath(workshopId, blockKey)),
};

export const sparkChatMutations = {
  resetSparkChat: ({
    workshopId,
    blockKey,
    chatId,
  }: {
    workshopId: WorkshopId;
    blockKey: string;
    chatId: string;
  }) =>
    post<OkResponse>(`${sparkChatPath(workshopId, blockKey)}/reset`, {
      chatId,
    }),
};
